import firebase from "firebase/app";
import "firebase/auth";

export const auth = firebase
  .initializeApp({
    apiKey: "AIzaSyDayIZ_AK_Dkul2FPkwRm5tj04wnQHWqXs",
    authDomain: "acacias-forum-d20ce.firebaseapp.com",
    projectId: "acacias-forum-d20ce",
    storageBucket: "acacias-forum-d20ce.appspot.com",
    messagingSenderId: "256173478825",
    appId: "1:256173478825:web:edd7c4dff7a13231afaab8",
    measurementId: "G-YN626H8L2D",
  })
  .auth();
